$(function(){
  
  /* ページ：お受験TOP
  ---------------------------------*/
  if($('.ojyuken-top').length >= 1){
    $('.js-inview').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('is-active');
      } else {
        $(this).removeClass('is-active');
      }
    });
    var top_mv = new Swiper('.js-swiper-ojyuken-top-mv', {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination-ojyuken-top-mv',
        clickable: true,
      },
    });
    var top_scene = new Swiper('.js-swiper-ojyuken-top-scene', {
      loop: true,
      slidesPerView: 1.4,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination-ojyuken-top-scene',
        clickable: true,
      },
    });
    var top_type = new Swiper('.js-swiper-ojyuken-top-type', {
      loop: true,
      slidesPerView: 1.4,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination-ojyuken-top-type',
        clickable: true,
      },
    });
  }//if($('.ojyuken-top').length >= 1)
  
  /* ページ：お受験の世界
  ---------------------------------*/
  if($('.ojyuken-study').length >= 1){
    var url = new URL(window.location.href);
    var param = url.searchParams;
    var param_tab = param.get('tab');
  
    var tab_init = 'schedule';
    if(param_tab && $('.js-ojyuken-study-tabcont[data-tab="'+param_tab+'"]').length >= 1){
      tab_init = param_tab;
    }
  
    $('.js-ojyuken-study-tabcont').css('display','none');
    $('.js-ojyuken-study-tabcont[data-tab="'+tab_init+'"]').css('display','block');
    $('.js-ojyuken-study-tabnav button[data-tab="'+tab_init+'"]').addClass('is-active');
    
    $('.js-ojyuken-study-tabnav button').click(function(){
      tab = $(this).data('tab');
      $('.js-ojyuken-study-tabcont').css('display','none');
      $('.js-ojyuken-study-tabcont[data-tab="'+tab+'"]').css('display','block');
      $('.js-ojyuken-study-tabnav button').removeClass('is-active');
      $('.js-ojyuken-study-tabnav button[data-tab="'+tab+'"]').addClass('is-active');
    });
  }//if($('.ojyuken-study').length >= 1)
  
});